import styled from "styled-components";

import { blueGreyMui } from "@ryde/theme";

export const SearchWithButtonsStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;

  .search-container {
    flex: 1;
    min-width: 0;
  }

  .buttons-container {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .action-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    border-radius: 4px;
    cursor: pointer;
    color: ${blueGreyMui._500};
    transition: all 0.2s ease;

    &:hover {
      background-color: ${blueGreyMui._50};
      color: ${blueGreyMui._700};
    }

    &:active {
      background-color: ${blueGreyMui._100};
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;
